/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React from 'react';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import './LoanDataDisplay.scss';
import fmt from 'indian-number-format';
import dayjs from 'dayjs';

interface CashBookRow {
  rowType: 'opening' | 'closing' | 'transaction';
  date: string;
  transactionType: string;
  voucherNo: string;
  narration: string;
  onlineIn: number | null;
  onlineOut: number | null;
  onlineBalance: number;
  offlineIn: number | null;
  offlineOut: number | null;
  offlineBalance: number;
}

interface CashBookDisplayProps {
  data: CashBookRow[];
}

const formatAmt = (val: number | null) =>
  val === null || val === undefined ? '' : fmt.format(val);

const columns: ColumnsType<CashBookRow> = [
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    render: (val: string) => (val ? dayjs(val).format('DD-MM-YYYY') : ''),
  },
  {
    title: 'Transaction Type',
    dataIndex: 'transactionType',
    key: 'transactionType',
  },
  {
    title: 'Voucher/Bill No',
    dataIndex: 'voucherNo',
    key: 'voucherNo',
  },
  {
    title: 'Narration',
    dataIndex: 'narration',
    key: 'narration',
  },
  {
    title: 'Offline Payment (Out)',
    dataIndex: 'offlineOut',
    key: 'offlineOut',
    render: formatAmt,
  },
  {
    title: 'Offline Receipt (In)',
    dataIndex: 'offlineIn',
    key: 'offlineIn',
    render: formatAmt,
  },
  {
    title: 'Offline Opening Balance',
    dataIndex: 'offlineBalance',
    key: 'offlineBalance',
    render: (val: number) => fmt.format(val),
  },
  {
    title: 'Online Payment (Out)',
    dataIndex: 'onlineOut',
    key: 'onlineOut',
    render: formatAmt,
  },
  {
    title: 'Online Receipt (In)',
    dataIndex: 'onlineIn',
    key: 'onlineIn',
    render: formatAmt,
  },
  {
    title: 'Online Opening Balance',
    dataIndex: 'onlineBalance',
    key: 'onlineBalance',
    render: (val: number) => fmt.format(val),
  },
];

const CashBookDisplay: React.FC<CashBookDisplayProps> = ({ data }) => (
  <div className="loan-data-container">
    <h2>Cash Bank Book</h2>
    <Table
      columns={columns}
      dataSource={data}
      rowKey={(row, idx) => `${row.rowType}-${idx}`}
      pagination={false}
      rowClassName={(row) =>
        row.rowType === 'opening' || row.rowType === 'closing' ? 'totals-row' : ''
      }
    />
  </div>
);

export default CashBookDisplay;
